module.exports = __webpack_public_path__ + "static/media/sm.51b68507.svg";